module.exports = __webpack_public_path__ + "static/media/DTSA-2023-LOGO.92fa138f.png";